import React from "react";
import PropTypes from "prop-types";

import "./RefundTextareaField.sass";

function RefundTextareaField({
  value,
  handleValue,
  errorMsg,
  className,
  inputClass,
  errorClass,
  children,
  symbolsLimit,
  ...rest
}) {
  return (
    <div className={`textarea ${className}`}>
      <textarea
        {...rest}
        className={`textarea__input scrollable ${inputClass} ${
          errorMsg !== "" ? "textarea__input--error" : ""
        }`}
        value={value}
        onChange={handleValue}
      />
      {!errorMsg && symbolsLimit && (
        <span className="textarea__count">{`${value.length}/${symbolsLimit}`}</span>
      )}
      {errorMsg !== "" && (
        <span className={`textarea__error-msg  ${errorClass}`}>{errorMsg}</span>
      )}
      {children}
    </div>
  );
}

// --- propTypes --- //
RefundTextareaField.propTypes = {
  value: PropTypes.string.isRequired,
  handleValue: PropTypes.func.isRequired,
  symbolsLimit: PropTypes.number,
  errorMsg: PropTypes.string,
  className: PropTypes.string,
  inputClass: PropTypes.string,
  errorClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
RefundTextareaField.defaultProps = {
  errorMsg: "",
  className: "",
  symbolsLimit: null,
  inputClass: "",
  errorClass: "",
  children: null,
};
// --- propTypes --- //

export default RefundTextareaField;
